import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    GET: createAction('ACCOUNTS/TAGS/GET'),
    GET_MANAGED_TAGS: createAction('ACCOUNTS/TAGS/GET_MANAGED_TAGS'),
    GET_TAG_USERS: createAction('ACCOUNTS/TAGS/GET_TAG_USERS'),
    GET_TAG_USERS_SUCCESS: createAction('ACCOUNTS/TAGS/GET_TAG_USERS_SUCCESS'),
    ADD_NEW_TAG: createAction('ACCOUNTS/TAGS/ADD_NEW_TAG'),
    SET_NEW_TAG_INPUT: createAction('ACCOUNTS/TAGS/SET_NEW_TAG_INPUT'),
    ADD_NEW_TAG_SUCCESS: createAction('ACCOUNTS/TAGS/ADD_NEW_TAG_SUCCESS'),
    UPDATE_TAG_NAME: createAction('ACCOUNTS/TAGS/UPDATE_TAG_NAME'),
    UPDATE_TAG_NAME_SUCCESS: createAction('ACCOUNTS/TAGS/UPDATE_TAG_NAME_SUCCESS'),
    TAG_NAME_INPUT_ACTIVE: createAction('ACCOUNTS/TAGS/TAG_NAME_INPUT_ACTIVE'),
    ADD_PERMISSIONS: createAction('ACCOUNTS/TAGS/ADD_PERMISSIONS'),
    DELETE: createAction('ACCOUNTS/TAGS/DELETE'),
    SUCCESS: createAction('ACCOUNTS/TAGS/SUCCESS'),
    UPDATE_TAG_NAME_ERROR: createAction('ACCOUNTS/TAGS/UPDATE_TAG_NAME_ERROR'),
    ERROR: createAction('ACCOUNTS/TAGS/ERROR'),
};
export const initialState = Map({
    tags: [],
    isProcessing: false,
    error: false,
    newTagInput: false,
});
const reducer = handleActions({
    [actions.GET]: (state) => state.set('isProcessing', true),
    [actions.GET_MANAGED_TAGS]: (state) => state.set('isProcessing', true),
    [actions.SUCCESS]: (state, action) => state.set('isProcessing', false).set('tags', action.payload.tags),
    [actions.GET_TAG_USERS]: (state) => state.set('isProcessing', true),
    [actions.GET_TAG_USERS_SUCCESS]: (state, action) => {
        const { tagId, json } = action.payload;
        const idx = state
            .get('tags')
            .findIndex((item) => item.tagId === tagId);
        return state
            .setIn(['tags', idx, 'members'], json.members)
            .set('isProcessing', false);
    },
    [actions.UPDATE_TAG_NAME]: (state) => state.set('isProcessing', true),
    [actions.TAG_NAME_INPUT_ACTIVE]: (state, action) => {
        const { tagId, active } = action.payload;
        const idx = state
            .get('tags')
            .findIndex((item) => item.tagId === tagId);
        return state.setIn(['tags', idx, 'active'], active);
    },
    [actions.UPDATE_TAG_NAME_SUCCESS]: (state, action) => {
        const { tagId, newTagName } = action.payload;
        const idx = state
            .get('tags')
            .findIndex((item) => item.tagId === tagId);
        return state
            .setIn(['tags', idx, 'name'], newTagName)
            .setIn(['tags', idx, 'error'], false)
            .setIn(['tags', idx, 'active'], false)
            .set('isProcessing', false)
            .set('error', false);
    },
    [actions.ERROR]: (state, action) => state.set('isProcessing', false).set('error', action.payload
        ? {
            exceptionId: action.payload.exceptionId,
            statusCode: action.payload.statusCode,
        }
        : true),
    [actions.UPDATE_TAG_NAME_ERROR]: (state, action) => {
        const { errorObj, tagId } = action.payload;
        const idx = state
            .get('tags')
            .findIndex((item) => item.tagId === tagId);
        return state
            .setIn(['tags', idx, 'error'], errorObj)
            .set('isProcessing', false);
    },
    [actions.ADD_NEW_TAG]: (state) => state.set('isProcessing', true),
    [actions.SET_NEW_TAG_INPUT]: (state, action) => state.set('newTagInput', action.payload),
    [actions.ADD_NEW_TAG_SUCCESS]: (state) => state
        .set('error', false)
        .set('isProcessing', false)
        .set('newTagInput', false),
}, initialState);
export default reducer;
